import EmptyState from '@components/EmptyState'
import { GetTravelSegmentResponse } from '@orbit/api-types'
import React from 'react'
import {
	BoardContainer,
	ColumnsContainer,
	ScrollableColumnsWrapper,
} from '../Itinerary/Board/Board.styles'
import { Itinerary } from '../Itinerary/types'
import ReadOnlyColumn from './ReadOnlyColumn'
import TripHeader from './TripHeader'

interface ReadOnlyBoardProps {
	itinerary: Itinerary
	tripName: string
	dayCount: number
	tripStartDate: string
	tripEndDate: string
	travelSegments?: GetTravelSegmentResponse[]
}

const ReadOnlyBoard: React.FC<ReadOnlyBoardProps> = ({
	itinerary,
	tripName,
	dayCount,
	tripStartDate,
	tripEndDate,
	travelSegments,
}) => {
	if (!itinerary.days || itinerary.days.length === 0) {
		return (
			<BoardContainer>
				<EmptyState
					art="itinerary"
					title="No itinerary yet"
					description="This trip doesn't have any itinerary days yet."
				/>
			</BoardContainer>
		)
	}

	return (
		<BoardContainer>
			<TripHeader
				tripName={tripName}
				dayCount={dayCount}
				startDate={tripStartDate}
				endDate={tripEndDate}
			/>

			<ScrollableColumnsWrapper>
				<ColumnsContainer id="board-column-container">
					{itinerary.days.map(day => (
						<ReadOnlyColumn
							key={day.id}
							day={day}
							travelSegments={travelSegments}
						/>
					))}
				</ColumnsContainer>
			</ScrollableColumnsWrapper>
		</BoardContainer>
	)
}

export default ReadOnlyBoard
